module.exports = __webpack_public_path__ + "static/media/HDFC_logo.6569364f.png";